export default __webpack_public_path__ + "images/close-2.svg";